import React from 'react';
import { Grid, InputLabel, OutlinedInput } from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import { DataGrid, GridColDef } from '@mui/x-data-grid';
import PageHeader from '../../../components/page-header';
import { FilterPanel } from '../../../components/filter-panel';
import { GridPanel, dataGridDefaults } from '../../../components/list-grid-panel';
import { RowAction } from '../../../components/row-action';
import { usePagedList } from '../../../hooks/use-paged-list';
import PoliticalPartyAppService from '../../../application/platform/sge/political-party/political-party-app-service';
import { usePoliticalPartySearchController } from './context/political-party-search-controller';
import { usePoliticalPartySearchState } from './context/political-party-search-context';
import { PoliticalPartyDrawer } from './components/political-party-drawer';

export function PoliticalPartySearchComponent() {
    const ctrl = usePoliticalPartySearchController();
    const { parameters, searchTrigger, drawer } = usePoliticalPartySearchState();
    const { rows, rowCount, loading } = usePagedList(PoliticalPartyAppService.list, parameters, searchTrigger, 'Não foi possível carregar os partidos políticos');

    const columns: GridColDef[] = [
        { field: 'id', headerName: 'ID', width: 80 },
        { field: 'name', headerName: 'Nome', flex: 1, minWidth: 200 },
        { field: 'abbreviation', headerName: 'Sigla', width: 120 },
        { field: 'isActive', headerName: 'Ativo', width: 80, type: 'boolean' },
        {
            field: 'actions', headerName: 'Ações', width: 80, sortable: false,
            renderCell: (params) => (
                <RowAction title="Editar" onClick={() => ctrl.openDrawer(params.row)}>
                    <EditIcon fontSize="small" />
                </RowAction>
            )
        }
    ];

    return (
        <React.Fragment>
            <Grid item xs={12}>
                <PageHeader
                    title="Partidos Políticos"
                    subtitle="Gerencie os partidos políticos cadastrados"
                    breadcrumbs={[{ label: 'Partidos Políticos' }]}
                />
            </Grid>
            <Grid item xs={12}>
                <FilterPanel onClear={ctrl.handleClearFilters} onSearch={ctrl.handleSearch}>
                    <Grid item xs={12}>
                        <InputLabel>Buscar por nome ou sigla</InputLabel>
                        <OutlinedInput fullWidth name="input-term" value={parameters.term || ''} onChange={ctrl.handleOnChange} onKeyDown={(e) => e.key === 'Enter' && ctrl.handleSearch()} />
                    </Grid>
                </FilterPanel>
            </Grid>
            <Grid item xs={12}>
                <GridPanel addLabel="Novo partido" onAdd={() => ctrl.openDrawer()}>
                    <DataGrid
                        {...dataGridDefaults}
                        rows={rows}
                        columns={columns}
                        loading={loading}
                        rowCount={rowCount}
                        paginationMode="server"
                        paginationModel={{ page: parameters.page ?? 0, pageSize: parameters.pageSize ?? 25 }}
                        onPaginationModelChange={(model) => ctrl.handlePaginationChange(model.page, model.pageSize)}
                    />
                </GridPanel>
            </Grid>

            <PoliticalPartyDrawer
                open={drawer.open}
                initial={drawer.record}
                isSaving={ctrl.isSaving}
                onClose={ctrl.closeDrawer}
                onSave={ctrl.handleSave}
            />
        </React.Fragment>
    );
}
